const GA_MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID || "G-4SF759DTW1";

const CLARITY_PROJECT_ID =
  process.env.REACT_APP_CLARITY_PROJECT_ID || "y01m7v39rm";

let isInitialized = false;

/**
 * Initialize Google Analytics 4 & Microsoft Clarity matching bintrix_tech pattern exactly
 */
export const initAnalytics = () => {
  if (typeof window === "undefined" || isInitialized) return;

  // Initialize GA4 tag with send_page_view: true matching bintrix_tech
  if (GA_MEASUREMENT_ID && !document.getElementById("ga4-script")) {
    const gaScript = document.createElement("script");
    gaScript.id = "ga4-script";
    gaScript.async = true;
    gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(gaScript);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GA_MEASUREMENT_ID, {
      send_page_view: true,
      page_path: window.location.pathname,
    });
  }

  // Initialize Microsoft Clarity tag matching bintrix_tech
  if (CLARITY_PROJECT_ID && !window.clarity && !document.getElementById("clarity-script")) {
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.id = "clarity-script";
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      if (y && y.parentNode) {
        y.parentNode.insertBefore(t, y);
      } else {
        document.head.appendChild(t);
      }
    })(window, document, "clarity", "script", CLARITY_PROJECT_ID);
  }

  // Global Auto Click Tracker for all interactive elements matching bintrix_tech AutoClickTracker
  const handleGlobalClick = (event) => {
    try {
      const target = event.target;
      if (!target) return;

      const interactiveEl = target.closest(
        'a, button, [role="button"], input[type="submit"], input[type="button"], select, label'
      );
      if (!interactiveEl) return;

      const elementText = (
        interactiveEl.textContent ||
        interactiveEl.innerText ||
        interactiveEl.value ||
        interactiveEl.ariaLabel ||
        ""
      )
        .trim()
        .slice(0, 60);

      const href = interactiveEl.href || interactiveEl.getAttribute("href") || "";
      const id = interactiveEl.id || "";
      const tagName = interactiveEl.tagName ? interactiveEl.tagName.toLowerCase() : "";

      if (typeof window !== "undefined" && window.gtag) {
        window.gtag("event", "user_click", {
          event_category: "User Interaction",
          event_label: elementText || id || href || tagName,
          element_id: id,
          element_tag: tagName,
          link_url: href,
          page_location: window.location.href,
        });
      }

      if (typeof window !== "undefined" && window.clarity) {
        window.clarity("event", `click_${tagName}_${elementText.slice(0, 20)}`);
      }
    } catch (err) {
      // Ignore click listener errors silently
    }
  };

  document.addEventListener("click", handleGlobalClick, { capture: true });

  isInitialized = true;
};

/**
 * Tracks pageviews automatically on React SPA route changes matching bintrix_tech PageViewTracker
 */
export const trackPageView = (pathname = window.location.pathname, search = window.location.search) => {
  if (typeof window === "undefined") return;

  const url = pathname + (search ? search : "");

  if (GA_MEASUREMENT_ID && typeof window.gtag === "function") {
    window.gtag("config", GA_MEASUREMENT_ID, {
      page_path: url,
    });
  }

  if (CLARITY_PROJECT_ID && typeof window.clarity === "function") {
    try {
      window.clarity("set", "page_path", url);
    } catch (e) {}
  }
};

/**
 * Utility helper function to trigger custom events anywhere in your application
 */
export const sendGAEvent = (eventName, eventParams = {}) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", eventName, eventParams);
  }
  if (typeof window !== "undefined" && window.clarity) {
    try {
      window.clarity("event", eventName);
    } catch (e) {}
  }
};
